"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLoginProviderContext = useLoginProviderContext;
exports.useLoginDialogOpen = useLoginDialogOpen;
exports.useLoginDialogClose = useLoginDialogClose;
exports.useLoginDialogShowHandler = useLoginDialogShowHandler;
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _invariant = _interopRequireDefault(require("invariant"));

var _useIsAuthenticated = _interopRequireDefault(require("@sprinx/react-auth/useIsAuthenticated"));

var _LoginDialog = _interopRequireDefault(require("../LoginDialog"));

var Context = /*#__PURE__*/_react.default.createContext(null);

if (process.env.NODE_ENV !== 'production') {
  Context.displayName = 'LoginProviderContext';
}

var LoginProvider = function LoginProvider(_ref) {
  var children = _ref.children;

  var _React$useState = _react.default.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      showLoginDialog = _React$useState2[0],
      setShowLoginDialog = _React$useState2[1];

  var isAuth = (0, _useIsAuthenticated.default)();

  var handleCloseDialog = _react.default.useCallback(function () {
    if (showLoginDialog) setShowLoginDialog(false);
  }, [showLoginDialog]);

  var handleOpenDialog = _react.default.useCallback(function () {
    if (!isAuth) setShowLoginDialog(true);
  }, [isAuth]);

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Context.Provider, {
    value: {
      onOpenDialog: handleOpenDialog,
      onCloseDialog: handleCloseDialog,
      isAuth: isAuth
    }
  }, children), /*#__PURE__*/_react.default.createElement(_LoginDialog.default, {
    open: showLoginDialog,
    onClose: handleCloseDialog
  }));
};

LoginProvider.displayName = 'LoginProvider';
process.env.NODE_ENV !== "production" ? LoginProvider.propTypes = {
  children: _propTypes.default.node.isRequired
} : void 0;
var _default = LoginProvider;
exports.default = _default;

function useLoginProviderContext() {
  var ctx = _react.default.useContext(Context);

  (0, _invariant.default)(ctx, 'Dont use `useLoginProviderContext` outside of <LoginProvider>');
  return ctx;
}

function useLoginDialogOpen() {
  var _useLoginProviderCont = useLoginProviderContext(),
      onOpenDialog = _useLoginProviderCont.onOpenDialog;

  return onOpenDialog;
}

function useLoginDialogClose() {
  var _useLoginProviderCont2 = useLoginProviderContext(),
      onCloseDialog = _useLoginProviderCont2.onCloseDialog;

  return onCloseDialog;
}

function useLoginDialogShowHandler() {
  var _useLoginProviderCont3 = useLoginProviderContext(),
      onCloseDialog = _useLoginProviderCont3.onCloseDialog,
      onOpenDialog = _useLoginProviderCont3.onOpenDialog;

  return [onOpenDialog, onCloseDialog];
}